import './PageContact.scss'
import HeaderLine from '../../components/headerLine/HeaderLine'
import ContactHamMenu from './contactHamMenu/ContactHamMenu'

export default function PageContact(props) {
    return (
        <div className='page-contact fullpage'>
            <HeaderLine
                selectedPage={'contact'}
            />

            <aside>
                <ContactHamMenu
                    show={true}
                />
            </aside>
            <main className='page-contact-main'>
                <h1>+++ page-contact-main</h1>
            </main>
        </div>
    )
}
